import { backIn, scale } from "framer-motion";

export const HeaderStyles = {
  container: {
    position: "sticky" as const,
    top: 0,
    left: 0,
    right: 0,
    bg: "#FFFFFF",
    boxShadow: "md",
    maxWidth: "100%",
    p: "0",
    paddingTop: "env(safe-area-inset-top)",
    zIndex: 1000,
    transition: "all 0.5s ease",
  },
  nav: {
    justify: "space-between" as const,
    align: "center" as const,
    // px: [5, null, 20],
    height: ["85px", null, "auto"],
    px: ["10px", null, "20px"],
    transition:"all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",

    "@media (min-width: 320px) and (max-width: 440px)": {
      justifyContent: "center",
      padding: "",
    },
    // overflow:"hidden"
  },
  mobileMenuButton: {
    display: ["flex", null, "none"],
    "aria-label": "Abrir menu",
    color: "red.700",
    variant: "ghost" as const,
    size: "lg" as const,
    _hover: { bg: "red.100" },
    ml: 2,
  },
  logoBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: ["center", null, "flex-start"],
    flex: ["1", null, "0 1 auto"],
    cursor: "pointer",
    transition: "transform 0.2s ease-in-out",
    _hover: { transform: "scale(1.05)" },
    position: "relative", 

  },
  desktopNavLinks: {
    display: ["none", null, "flex"], 
    alignItems: "center",
    fontFamily: "merriweather",
    fontWeight: "bold",
    borderRadius: "20px",
    flexWrap: "wrap" as const,
  },
  mobileUserButton: {
    display: ["flex", null, "none"], 
    "aria-label": "Abrir usuário",
    color: "red.700",
    variant: "ghost" as const,
    size: "lg" as const,
    _hover: { bg: "red.100" },
    overflow:"hidden",
    mr: 2,
  },
  desktopUserMenu: {
    display: ["none", null, "flex"],
  },
};
export const HeaderComponentsStyles = {
  // Estilos da Nav links
  navLinkDesktop: {
    desktopNavLinksBox: {
      display: "flex",
      alignItems: "center",
      fontFamily: "merriweather",
      fontWeight: "bold",
      borderRadius: "20px",
      flexWrap: "wrap",
    },
    desktopNavLinkButton: {
      fontSize: "lg",
      transition: "transform 0.2s ease-in-out",
      bg: "transparent",
      borderWidth: "0",
      color: "black",
      textShadow: "1px 1px 4px rgba(0, 0, 0, 0.1)", 
      _hover: {
        transform: "scale(1.05)",
        color: "red-wine",
        textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)", 
      },
    },
    collapsibleContentStyles: {
      position: "absolute",
      top: "100%",
      left: 0,
      bg: "white",
      border: "1px solid #e0e0e0",
      borderRadius: "md",
      boxShadow: "md",
      zIndex: 10,
      minW: "200px",
    },
    collapsibleItemStyles: {
      direction: "column",
      display: "block",
      width: "100%",
      textAlign: "left",
      p: 3,
      fontWeight: "normal",
      _hover: {
        bg: "gray.100",
        color: "red",
      },
    },
    collapsibleItemLabelStyles: {
      fontWeight: "bold",
      fontSize: "sm",
      color: "black",
      fontFamily: "arial",
    },
    collapsibleItemDescriptionStyles: {
      fontSize: "xs",
      color: "gray.500",
    },
  },
  // Estilos do user menu
  userMenuDesktop: {
    desktopUserButtonsBox: {
      display: "flex",
      alignItems: "center",
      flexDirection: ["column", "column", "row"]
    },
    desktopLoginButton: {
      fontSize: { md: "md" },
      fontWeight: "bold",
      color: "#333333",
      p: "5",
      gap: { md: "3" },
      w: { sm: "auto" },
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
      boxShadow: "sm",
      bg: "white",
      borderWidth: "0",
    },
    desktopSignupButton: {
      fontSize: "md",
      fontWeight: "bold",
      color: "white",
      ml: "12px",
      bg: "red.700",
      p: "18px",
      transition: "transform 0.2s ease-in-out",
      boxShadow: "sm",
      _hover: { transform: "scale(1.05)", bg: "red.600" },
    },
    menuContent: {
      bg: "white",
      position:"absolute",
      top:"-3",
      w:"fit-content",
      pointerEvents:"auto",
      zIndex:"999",
      _hover: {
        bg: "white",
        color: "white",
      },
    },
    menuItemParent: {
      color: "gray.500",
      // borderBottom:"1px solid #D8D8D8",
      whiteSpace:"nowrap",
      bg: "white",
      transition:"all 0.2s ease-in-out",
      _hover: {
        color: "red-wine",
        bg: "white",
        transform:"scale(1.02)",
        fontWeight:"bold"
      },
      cursor: "pointer",
    },
    menuItem: {
      color: "gray.800",
      // borderBottom:"1px solid #D8D8D8",
      whiteSpace:"nowrap",
      bg: "white",
      transition:"all 0.2s ease-in-out",
      _hover: {
        color: "red-wine",
        bg: "white",
        transform:"scale(1.02)",
        fontWeight:"bold"
      },
      cursor: "pointer",
    },
    logoutButton: {
      align: "center",
      gap: "1",
      fontSize: "sm",
      color: "gray.600",
      _hover: { color: "red.500", cursor: "pointer" },
    },
  },
  // Estilos Menu esquerdo mobile
  leftSidebarMobile: {
    mobileMenuBox: {
      position: "fixed",
      top: "0",
      left: "0",
      bottom: "0",
      // width: "fit-content",
      width: "auto",
      boxShadow: "lg",
      zIndex: "overlay",
      transition: "transform 0.6s ease",
      bg: "white",
      height: "100vh",
      overflowY: "auto",

      paddingTop: "env(safe-area-inset-top, 20px)",
    },
    mobileMenuHeader: {
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
      ml: 2,
      width: "100%",
      px: 4,
      py: 2,
      display: "flex",
      borderRadius: "lg",
      fontFamily: "merriweather",
    },
    mobileMenuHeaderText: {
      fontWeight: "bold",
      fontSize: "lg",
      color: "red-wine",
    },
    mobileMenuItemButton: {
      justifyContent: "flex-start",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
      color: "#333333",
      bg:"transparent",
    },
    mobileMenuOverlay: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      zIndex: "91",
      bg: "blackAlpha.600",
    },
    institucionalSubmenuBox: {
      mb: 4,
      borderLeft: "2px solid",
      borderColor: "red-wine",
    },
    institucionalSubmenuItem: {
      justifyContent: "flex-start",
      fontSize: "sm",
      fontWeight: "normal",
      py: 2,
      color: "#555555",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.03)" },
      bg:"transparent",
    },
    institucionalItemButton: {
      backgroundColor: "white",
      justifyContent: "space-between",
      width: "100%",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
      color: "#333333",
    },
  },
  // Estilos Menu direito mobile
  rightSidebarMobile: {
    mobileMenuBox: {
      position: "fixed",
      top: "0",
      right: "0",
      bottom: "0",
      width: "fit-content",
      boxShadow: "lg",
      zIndex: "overlay",
      transition: "transform 0.6s ease",
      bg: "white",
      height: "100vh",
      overflowY: "auto",

      paddingTop: "env(safe-area-inset-top, 20px)",
    },
    mobileMenuHeader: {
      justifyContent: "space-between",
      alignItems: "center",
      mb: 2,
      ml: 2,
      width: "100%",
      px: 4,
      py: 2,
      display: "flex",
      borderRadius: "lg",
      fontFamily: "merriweather",
    },
    mobileMenuHeaderText: {
      fontWeight: "bold",
      fontSize: "lg",
      color: "red-wine",
    },
    flexAvatar:{
      direction:"column", 
      align:"center",
      gap:0, 
      px:6,
      py:0,
      mb:"4"
    },
    div:{
      h:"1px", 
      my:"2", 
      w:"full"
    },
    mainFlexConsultCode:{
      align:"center",
      gap:"1",
      direction:"column"
    },
    flexConsultCode:{
      align:"center", 
      gap:"2",
      bg:"red-wine",
      borderRadius:"lg",
      boxShadow:"sm",
      p:"1"
    },
    ItemButton: {
      justifyContent: "space-between",
      width: "100%",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
      color: "#333333",
      background: "white",
    },
    mobileMenuLoginButton: {
      w: "full",
      mb: 3,
      fontSize: "md",
      fontWeight: "bold",
      color: "gray.600",
      bg: "transparent",
      justifyContent: "flex-start",
      p: "10px",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
    },
    mobileMenuSignupButton: {
      w: "full",
      fontSize: "md",
      fontWeight: "bold",
      color: "gray.600",
      justifyContent: "flex-start",
      bg: "transparent",
      p: "10px",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
    },

    mobileMenuItemButton: {
      justifyContent: "flex-start",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.05)" },
      color: "#333333",
      bg:"transparent",
    },
    mobileMenuOverlay: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      zIndex: "91",
      bg: "blackAlpha.600",
    },
    SubmenuBox: {
      mb: 2,
      borderLeft: "2px solid",
      borderColor: "red-wine",
    },
    SubmenuItem: {
      justifyContent: "flex-start",
      fontSize: "sm",
      fontWeight: "normal",
      py: 2,
      color: "#555555",
      transition: "transform 0.2s ease-in-out",
      _hover: { transform: "scale(1.03)" },
      bg:"transparent",
      display:"flex",
      flexDir:"column",
      alignItems:"flex-start",
      width:"100%"
    },
  },
};

export const LoginPromptHeaderStyles = {
  container: {
    bg: "red-wine",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 4,
    color: "white",
    flexWrap: "wrap",
    w: "100%",
    zIndex: 2000,
    willChange: "transform, opacity, max-height",
    backfaceVisibility: "hidden",
    boxShadow:"sm",
    gap: 6,
  },
  textBox: {
    justify: "center",
    px: 4,
    mb: [0, 0],
  },

  text: {
    fontSize: ["12px","14px"],
    fontWeight: "semibold",
  },
  contactWrapper: {
    align: "center",
    gap: [0, 0, 6, 12],
    justifyContent: "center",
    flexWrap: "wrap",
    display: ["none", "flex"],
    px: 4,
  },
  contactItem: {
    align: "center",
    gap: 3,
    mb: [1, 0],
    px: 2,
  },
  contactText: {
    fontSize: ["12px", "14px"],
    fontWeight: "semibold",
  },
};